import { IndianRupee, Package, Percent, FileText, TrendingUp } from "lucide-react";
import { STATUS_CONFIG, formatCompact, formatCurrency } from "./pharmacyConstants";

export function PharmacyKPIs({ summary }) {
  if (!summary) return null;
  return (
    <div className="space-y-3" data-testid="kpi-section">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {[
          { label: "Total Revenue", value: formatCompact(summary.total_revenue), icon: IndianRupee, bg: "bg-slate-900", text: "text-white", iconColor: "text-slate-400" },
          { label: "Total Orders", value: summary.total_orders.toLocaleString(), icon: Package, bg: "bg-teal-50", text: "text-teal-700", iconColor: "text-teal-500", border: "border-teal-200" },
          { label: "Total Discount", value: formatCompact(summary.total_discount), icon: Percent, bg: "bg-orange-50", text: "text-orange-700", iconColor: "text-orange-500", border: "border-orange-200" },
          { label: "Total Tax", value: formatCompact(summary.total_tax), icon: FileText, bg: "bg-blue-50", text: "text-blue-700", iconColor: "text-blue-500", border: "border-blue-200" },
          { label: "Collection Efficiency", value: `${summary.collection_efficiency}%`, icon: TrendingUp, bg: "bg-emerald-50", text: "text-emerald-700", iconColor: "text-emerald-500", border: "border-emerald-200" },
        ].map((kpi, i) => (
          <div key={i} className={`${kpi.bg} ${kpi.border ? `border ${kpi.border}` : ""} rounded-xl p-4`} data-testid={`kpi-${kpi.label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-center gap-2 mb-2">
              <kpi.icon className={`w-4 h-4 ${kpi.iconColor}`} />
              <span className={`text-[10px] font-semibold uppercase tracking-wider ${kpi.bg === "bg-slate-900" ? "text-slate-400" : "text-slate-500"}`}>{kpi.label}</span>
            </div>
            <p className={`text-xl font-bold ${kpi.text}`}>{kpi.value}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="status-kpis">
        {[
          { label: "Paid", amount: summary.paid_amount, count: summary.paid_count, cfg: STATUS_CONFIG[303] },
          { label: "Pending", amount: summary.pending_amount, count: summary.pending_count, cfg: STATUS_CONFIG[301] },
          { label: "Insurance Credit", amount: summary.insurance_credit_amount, count: summary.insurance_credit_count, cfg: STATUS_CONFIG[306] },
          { label: "Self Credit", amount: summary.self_credit_amount, count: summary.self_credit_count, cfg: STATUS_CONFIG[307] || STATUS_CONFIG[306] },
          { label: "Cancelled", amount: summary.cancelled_amount, count: summary.cancelled_count, cfg: STATUS_CONFIG[304] || STATUS_CONFIG[305] },
          { label: "Refunded", amount: summary.refunded_amount, count: summary.refunded_count, cfg: STATUS_CONFIG[305] },
        ].map((s, i) => (
          <div key={i} className={`${s.cfg.bg} border ${s.cfg.border} rounded-xl p-3`}>
            <div className="flex items-center gap-1.5 mb-1">
              <span className={`w-2 h-2 rounded-full ${s.cfg.dot}`} />
              <span className="text-[10px] font-semibold text-slate-500 uppercase">{s.label}</span>
            </div>
            <p className={`text-lg font-bold ${s.cfg.color}`}>{formatCompact(s.amount)}</p>
            <p className="text-[10px] text-slate-400">{s.count} orders</p>
          </div>
        ))}
        <div className="bg-white border border-slate-200 rounded-xl p-3 col-span-2 flex items-center gap-4">
          <div className="flex-1">
            <p className="text-[10px] font-semibold text-slate-500 uppercase mb-1">Medicines Dispensed</p>
            <p className="text-lg font-bold text-slate-800">{summary.total_medicines?.toLocaleString() || 0}</p>
          </div>
          <div className="flex-1">
            <p className="text-[10px] font-semibold text-slate-500 uppercase mb-1">Avg Order Value</p>
            <p className="text-lg font-bold text-slate-800">{summary.total_orders > 0 ? formatCurrency(summary.total_revenue / summary.total_orders) : "\u2014"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
